<template>
  <div
    class="subscribe__right"
    :class="{
      empty: !items?.length,
      open: isOpen
    }"
  >
    <div class="subscribe__right-top">
      <div class="subscribe__right-top-content">
        <div class="subscribe__right-header h6">{{ t('header') }}</div>
        <div class="subscribe__right-top-content-count">
          <span>Блоки</span>
          <span>{{ selectedCount }}/{{ maxBlocks }}</span>
        </div>
      </div>

      <button class="subscribe__right-top-toggler" type="button" @click="toggleRight" :aria-label="isOpen ? t('toggleAriaLabelClose') : t('toggleAriaLabelOpen')">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7369 19.2862C24.0982 18.9383 24.0859 18.3857 23.7093 18.052L16.6542 11.7978C16.2886 11.4737 15.7114 11.4737 15.3458 11.7978L8.29067 18.052C7.91414 18.3857 7.9018 18.9383 8.26311 19.2862C8.62443 19.634 9.22256 19.6454 9.59909 19.3116L16 13.6374L22.4009 19.3116C22.7774 19.6454 23.3756 19.634 23.7369 19.2862Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <template v-show="!items?.length">
      <div class="subscribe__right-total">
        <span>{{ t('totalLabel') }}</span>
        <span class="subscribe__right-total-value">{{ totalSum }} грн</span>
      </div>
    </template>

    <div class="subscribe__right-progress-bar progress-bar">
      <div class="progress-bar__top">
        <div class="progress-bar__title">Блоки</div>
        <div class="progress-bar__min">{{ t('minLabel') }}</div>
        <div class="progress-bar__count">{{ selectedCount }}/{{ maxBlocks }}</div>
      </div>

      <div class="progress-bar__bar">
        <div class="progress-bar__fill" :style="{ width: progressPercent + '%' }"></div>
      </div>
    </div>

    <div class="subscribe__right-selected" v-if="items?.length">
      <div class="subscribe__right-selected-items">
        <div
          class="subscribe__right-selected-item"
          v-for="item in items"
          :key="itemKey(item)"
        >
          <div class="subscribe__right-selected-img">
            <img :src="item?.product?.images?.[0]" :alt="item?.product?.image_alt || ''" />
          </div>

          <div class="subscribe__right-selected-main">
            <div class="subscribe__right-selected-container">
              <div class="subscribe__right-selected-title">
                {{ item?.product?.product_title }}
              </div>

              <button
                type="button"
                class="btn-clear-one"
                @click="$emit('clear-item', item.product)"
                aria-label="Видалити позицію"
              >
								<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M8.81506 0.666992C9.9196 0.667035 10.8151 1.56245 10.8151 2.66699V3.33301H14.3707C14.6835 3.33322 14.9371 3.58756 14.9371 3.90039C14.9369 4.21304 14.6834 4.46658 14.3707 4.4668H13.7281L13.3112 12.7998C13.2402 14.219 12.0691 15.333 10.6481 15.333H5.05432C3.63354 15.3328 2.46219 14.2189 2.39124 12.7998L1.97424 4.4668H1.33362C1.02079 4.4668 0.766444 4.21317 0.766235 3.90039C0.766235 3.58743 1.02066 3.33301 1.33362 3.33301H4.88928V2.66699C4.88928 1.56242 5.78471 0.666992 6.88928 0.666992H8.81506ZM3.52307 12.7432C3.56387 13.5591 4.23746 14.1999 5.05432 14.2002H10.6481C11.4651 14.2002 12.1385 13.5592 12.1793 12.7432L12.5856 4.61523H3.11682L3.52307 12.7432ZM6.07483 7.0625C6.38779 7.0625 6.64124 7.31692 6.64124 7.62988V10.5928C6.64112 10.9056 6.38772 11.1592 6.07483 11.1592C5.76197 11.1591 5.50853 10.9056 5.50842 10.5928V7.62988C5.50842 7.31694 5.7619 7.06254 6.07483 7.0625ZM9.62854 7.0625C9.9415 7.0625 10.1959 7.31692 10.1959 7.62988V10.5928C10.1958 10.9056 9.94143 11.1592 9.62854 11.1592C9.31583 11.159 9.06225 10.9055 9.06213 10.5928V7.62988C9.06213 7.31705 9.31576 7.06271 9.62854 7.0625ZM6.88928 1.7998C6.41064 1.7998 6.02209 2.18835 6.02209 2.66699V3.08887H9.68127V2.66699C9.68127 2.18837 9.29367 1.79985 8.81506 1.7998H6.88928Z" fill="#6F7171"/>
								</svg>

							</button>
            </div>

            <div class="subscribe__right-selected-container">
              <div class="subscribe__right-selected-qty">
                <button
                  type="button"
                  class="qty-btn"
                  @click="$emit('decrease', item.product)"
                  :aria-label="t('qtyBtnMinusAriaLabe')"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                    <path d="M8.25 3.75H0.75C0.335786 3.75 0 4.08579 0 4.5C0 4.91421 0.335786 5.25 0.75 5.25H8.25C8.66421 5.25 9 4.91421 9 4.5C9 4.08579 8.66421 3.75 8.25 3.75Z" fill="currentColor"/>
                  </svg>
                </button>

                <span class="qty-val">{{ item.qty }}</span>

                <div
                  class="qty-plus-wrap"
                  :data-plus-tip-active="activePlusTipKey === itemKey(item) ? 'true' : null"
                >
                  <button
                    type="button"
                    class="qty-btn"
                    :class="{ 'is-disabled': isPlusDisabled(item) }"
                    :aria-label="t('qtyBtnPlusAriaLabe')"
                    :aria-disabled="isPlusDisabled(item)"
                    :aria-describedby="isPlusDisabled(item) && activePlusTipKey === itemKey(item) ? plusTipId(item) : null"
                    @click="handlePlusClick(item)"
                    @blur="hidePlusTip"
                    @keydown.esc.stop.prevent="hidePlusTip"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                      <path d="M8.25 3.75H0.75C0.335786 3.75 0 4.08579 0 4.5C0 4.91421 0.335786 5.25 0.75 5.25H8.25C8.66421 5.25 9 4.91421 9 4.5C9 4.08579 8.66421 3.75 8.25 3.75Z" fill="currentColor"/>
                      <path d="M5.25 8.25V0.75C5.25 0.335786 4.91421 0 4.5 0C4.08579 0 3.75 0.335786 3.75 0.75V8.25C3.75 8.66421 4.08579 9 4.5 9C4.91421 9 5.25 8.66421 5.25 8.25Z" fill="currentColor"/>
                    </svg>
                  </button>

                  <div
                    v-if="isSubscriptionLimitReached(item) && activePlusTipKey === itemKey(item)"
                    class="qty-tooltip"
                    :id="plusTipId(item)"
                    role="tooltip"
                  >
                    {{ t('qtyTooltip') }}
                  </div>

                  <div
                    v-else-if="!canAddMore && activePlusTipKey === itemKey(item)"
                    class="qty-tooltip"
                    :id="plusTipId(item)"
                    role="tooltip"
                    v-html="t('tooltip')"
                  ></div>
                </div>
              </div>

              <div class="subscribe__right-selected-price">
                {{ item?.product?.product_price }} грн
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="subscribe__right-summary">
        <div class="subscribe__right-summary-delivery">
          <span>Доставка</span>
          <span>{{ t('deliveryFreeLabel') }}</span>
        </div>
        <div class="subscribe__right-summary-total">
          <span>{{ t('totalLabel') }}</span>
          <span>{{ totalSum }} грн</span>
        </div>
      </div>
    </div>

    <div class="subscribe__right-text" v-else>
      {{ t('rightText') }}
    </div>

    <button
      class="subscribe__right-next-step btn btn--orange"
      :class="{ disabled: isNextDisabled }"
      :aria-disabled="isNextDisabled ? 'true' : undefined"
      :disabled="disabled"
      type="button"
      @click="$emit('next')"
    >
      <template v-if="isLoading">
        <Loader />
      </template>
      <template v-else>
        {{ nextLabel }}
      </template>
    </button>

    <button
      v-if="items?.length"
      type="button"
      class="subscribe__right-clear-all"
      @click="$emit('clear-all')"
      :disabled="selectedCount === 0"
    >
      {{ t('clearSubscribe') }}
    </button>
  </div>
</template>

<script setup>
import Loader from '@/account/components/Loader.vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  selectedCount: { type: Number, default: 0 },
  maxBlocks: { type: Number, default: 5 },
  progressPercent: { type: Number, default: 0 },
  totalSum: { type: [Number, String], default: 0 },
  canAddMore: { type: Boolean, default: true },
  canGoNextBtn: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  activeStep: { type: Number, default: 1 },
  itemKeyFn: { type: Function, default: null },
  getSubscriptionQty: { type: Function, default: () => 0 },
  hasSubscription: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})

const emit = defineEmits(['increase', 'decrease', 'clear-item', 'clear-all', 'next'])

const i18n = {
  uk: {
    header: 'Моя підписка',
    minLabel: 'мін',
    tooltip: 'В послузі може бути не більше <span>5 блоків стіків</span>',
    subscriptionTooltipPrefix: 'Для цього товару не можна обрати більше ніж',
    totalLabel: 'Всього:',
    deliveryFreeLabel: 'Безкоштовно',
    hasSubscribeBtnLabel: 'ЗБЕРЕГТИ ЗМІНИ',
    subscribeBtnLabel: 'ОФОРМИТИ ПІДПИСКУ',
    nextStepBtnLabel: 'НАСТУПНИЙ КРОК',
    disabledBtnLabel: 'Тимчасово недоступно',
    clearSubscribe: 'Очистити дані',
    rightText: 'Обери блоки стіків, які хочеш отримувати',
    qtyTooltip: 'Ці стіки вже додані до підписки. Їх можна лише видалити АБО додати повторно за оновленою ціною',
    qtyBtnMinusAriaLabe: 'Зменшити кількість',
    qtyBtnPlusAriaLabe: 'Збільшити кількість',
    toggleAriaLabelOpen: 'Відкрити додаткову інформацію',
    toggleAriaLabelClose: 'Закрити додаткову інформацію'
  },
  ru: {
    header: 'Моя подписка',
    minLabel: 'мин',
    tooltip: 'В услуге может быть не более <span>5 блоков стиков</span>',
    subscriptionTooltipPrefix: 'Для этого товара нельзя выбрать больше чем',
    totalLabel: 'Всего:',
    deliveryFreeLabel: 'Бесплатно',
    hasSubscribeBtnLabel: 'СОХРАНИТЬ ИЗМЕНЕНИЯ',
    subscribeBtnLabel: 'ОФОРМИТЬ ПОДПИСКУ',
    nextStepBtnLabel: 'СЛЕДУЮЩИЙ ШАГ',
    disabledBtnLabel: 'Временно недоступно',
    clearSubscribe: 'Очистить данные',
    rightText: 'Выбери наборы стиков, которые хочешь получать',
    qtyTooltip: 'Эти стики уже добавлены в подписку. Их можно только удалить ИЛИ добавить повторно по обновленной цене',
    qtyBtnMinusAriaLabe: 'Уменьшить количество',
    qtyBtnPlusAriaLabe: 'Увеличить количество',
    toggleAriaLabelOpen: 'Открыть дополнительную информацию',
    toggleAriaLabelClose: 'Скрыть дополнительную информацию'
  }
}

const locale = computed(() => window.Shopify?.locale || 'uk')
const t = (key) => i18n[locale.value]?.[key] || key

const itemKey = (item) => {
  if (props.itemKeyFn) return props.itemKeyFn(item)
  return item?.product?.id ?? item?.product?.handle ?? item?.product?.product_title
}

const nextLabel = computed(() => {
  if (props.disabled) return t('disabledBtnLabel')

  return props.activeStep === 3 ? (props.hasSubscription ? t('hasSubscribeBtnLabel') :t('subscribeBtnLabel')) : t('nextStepBtnLabel')
})

const isNextDisabled = computed(() => props.disabled || (props.activeStep !== 3 && !props.canGoNextBtn))

const isOpen = ref(false)
const toggleRight = () => { isOpen.value = !isOpen.value }

const activePlusTipKey = ref(null)
const plusTipId = (item) => `qty-plus-tooltip-${itemKey(item)}`

const hidePlusTip = () => {
  activePlusTipKey.value = null
}

const onDocumentPointerDown = (event) => {
  if (!activePlusTipKey.value) return

  const target = event.target
  if (!(target instanceof Element)) {
    hidePlusTip()
    return
  }

  if (target.closest('.qty-plus-wrap[data-plus-tip-active="true"]')) return

  hidePlusTip()
}

const isSubscriptionLimitReached = (item) => {
  const subscriptionQty = Number(props.getSubscriptionQty(item.product) || 0)
  return subscriptionQty > 0 && item.qty >= subscriptionQty
}

const isPlusDisabled = (item) => {
  return !props.canAddMore || isSubscriptionLimitReached(item)
}

const handlePlusClick = (item) => {
  const key = itemKey(item)

  if (isPlusDisabled(item)) {
    activePlusTipKey.value = key
    return
  }

  emit('increase', item.product)
  hidePlusTip()
}

onMounted(() => {
  document.addEventListener('pointerdown', onDocumentPointerDown, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('pointerdown', onDocumentPointerDown, true)
})

</script>
